import { getConfig } from "@/lib/config";

// Die zwei Betriebsarten des Prototyps tobis, beide aus /config.js (siehe
// TOBIS_STANDALONE_MODE und TOBIS_DETACHED_MODE in apps/bff/src/config.ts).
// Funktionen statt Konstanten: getConfig() darf erst laufen, wenn /config.js
// geladen ist, nicht schon beim Import.

// Instanz nur fuer tobis: Kernprodukt-Saeulen und globale Suche ausgeblendet.
export function isTobisStandalone(): boolean {
  return getConfig().featureFlags?.tobisStandalone === true;
}

// Instanz ohne genesis und agent-service: alles, was diese Backends braucht,
// bleibt unsichtbar, statt ins Leere zu laufen.
export function isTobisDetached(): boolean {
  return getConfig().featureFlags?.tobisDetached === true;
}
